import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

export const SCREEN_SIZE = 'Screen Size';
// Stored value keeps the original spelling so saved items still match.
export const SUB_FRAME = 'Sub Frame(Box profie 3/4"x1 1/2")';

// `screenSizeOnly` hides the sub frame option (profiles that can't be mounted on a sub frame).
const MeasurmentType = ({ value, onChange, label = 'Measurment Type:', disabled = false, screenSizeOnly = false }) => {
    const [selectedMeasurmentType, setSelectedMeasurmentType] = useState(value || SCREEN_SIZE);

    useEffect(() => {
        setSelectedMeasurmentType(value || SCREEN_SIZE);
    }, [value]);

    const handleMeasurmentTypeChange = (e) => {
        setSelectedMeasurmentType(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label   disabled={disabled} htmlFor="MeasurmentType">{label}</label>
            <select
                disabled={disabled}
                id="MeasurmentType"
                value={selectedMeasurmentType}
                onChange={handleMeasurmentTypeChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value={SCREEN_SIZE}>{selectedMeasurmentType === SCREEN_SIZE ? 'Screen Size ✔' : 'Screen Size'}</option>
                {!screenSizeOnly && (
                <option value={SUB_FRAME}>
                {selectedMeasurmentType === SUB_FRAME ? 'Sub Frame (Box profile 3/4"x1 1/2") ✔' : 'Sub Frame (Box profile 3/4"x1 1/2")'}
                </option>
                )}
            </select>
        </div>
    );
};

export default MeasurmentType;
